import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../../utils/api';
import '../../styles/admin/EditProjects.css';
import ProtectedAdminRoute from '../../components/ProtectedAdminRoute';
import FileUpload from '../../components/FileUpload';

// Removed BACKEND_URL, use apiFetch instead

export default function EditTeamImage() {
  const [form, setForm] = useState({
    teamImage: '',
    teamImageAlt: ''
  });
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  
  const navigate = useNavigate();

  useEffect(() => {
    fetchTeamSettings();
  }, []);

  const fetchTeamSettings = async () => {
    try {
      const data = await apiFetch('/api/team-settings');
      setForm({
        teamImage: data.teamImage || '',
        teamImageAlt: data.teamImageAlt || ''
      });
    } catch (error) {
      console.error('Error fetching team settings:', error);
      setMessage('Error loading team settings');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const data = await apiFetch('/api/team-settings', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      if (data && data.success) {
        setMessage('Team image updated successfully!');
        setTimeout(() => navigate('/admin'), 1500);
      } else {
        setMessage('Failed to update team image');
      }
    } catch (error) {
      console.error('Error updating team settings:', error);
      setMessage('Failed to update team image');
    }
  };

  if (loading) {
    return (
      <ProtectedAdminRoute>
        <div className="add-project-flex">
          <div className="edit-project-form">
            <div className="loading">Loading team settings...</div>
          </div>
        </div>
      </ProtectedAdminRoute>
    );
  }

  return (
    <ProtectedAdminRoute>
      <div className="add-project-flex">
        <div className="edit-project-form">
          <h2>Edit Team Image</h2>
          
          {message && (
            <div className={`message ${message.includes('Error') || message.includes('Failed') ? 'error' : 'success'}`}>
              {message}
            </div>
          )}

          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="form-group">
              <FileUpload
                label="Team Image"
                currentUrl={form.teamImage}
                onUpload={(url) => setForm({...form, teamImage: url})}
                accept="image/*"
                showPreview={true}
              />
            </div>

            <div className="form-group">
              <label htmlFor="teamImageAlt">Image Description</label>
              <input
                id="teamImageAlt"
                name="teamImageAlt"
                placeholder="Brief description of the team image"
                value={form.teamImageAlt}
                onChange={handleChange}
                autoComplete="off"
              />
              <small className="form-help">Used for accessibility and screen readers</small>
            </div>

            <div className="form-actions">
              <button type="submit" className="submit-btn">
                Save Changes
              </button>
              <button 
                type="button" 
                className="cancel-btn"
                onClick={() => navigate('/admin')}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </ProtectedAdminRoute>
  );
}
